import { ControlValueAccessor } from "@angular/forms"
import { EConductivite } from "./enum/conductivite"
import { ControleConductivite } from "./controle-conductivite"

export class AjustageConductivite {

    Code: string
    // Type: EConductivite
    NumeroLot: string
    DateOuverture: Date

    ControleConductivite: ControleConductivite = new ControleConductivite()

    static mapFromJSON(json: any): AjustageConductivite {
        const ms = new AjustageConductivite();

        ms.Code = json.code;
        // ms.Type = json.type;
        ms.NumeroLot = json.numeroLot;
        ms.DateOuverture = json.dateOuverture;

        if (json.controleConductivite) {
            ms.ControleConductivite = ControleConductivite.mapFromJSON(json.controleConductivite);
        }
        // if (json.ajustagePHList) {
        //     ms.AjustagePHList = json.ajustagePHList.map(jsonItem => AjustagePH.mapFromJSON(jsonItem));
        // }
        return ms;
    }
}